import * as React from 'react';
import { Box, Typography, Button, Stack, useTheme } from '@mui/material';
import BackButton from '../../../components/BackButton';
import LabelTxtFieldInfo from '../../../components/LabelTxtFieldInfo';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../context/AuthContext';
import { useState } from 'react';
import route from '../../../utils/Routes';
import { customAlert, notify } from '../../../components/notify';
import { useEffect } from 'react';
import { editProjServ, getSingleProjServ } from '../../../services/proj-service';
import BgBoxOld from '../../../components/BgBoxOld';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { isNotEmpty } from '../../../utils/format';


export default function EditProject() {
    const theme = useTheme();
    const navigate = useNavigate();
    const location = useLocation();
    const { comId, projId } = location.state || {};
    const { setLoadingScreen, setNavComValue } = useAuthContext();
    const [formErrors, setFormErrors] = useState({});
    const txtFieldSx = { width: 300, height: 30, borderRadius: 1 };
    const { isLoading, isError, error, data: projData } = useQuery([QueryKey.projInfo, projId],
        () => getSingleProjServ(projId),
        {
            enabled: isNotEmpty(projId),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
            retry: false
        });

    useEffect(() => {
        setLoadingScreen(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);


    useEffect(() => {
        if (!comId)
            navigate("/", { replace: true })
        else if (!projId)
            navigate("/", { replace: true })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comId, projId])

    useEffect(() => {
        setNavComValue({ comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);


    async function handleSubmit(e) {
        e.preventDefault();
        const formData = new FormData(e.target);
        const inputObject = Object.fromEntries(formData); // convert the FormData object to a JSON object
        let errorsObj = validate(inputObject);
        setFormErrors(errorsObj);
        if (Object.keys(errorsObj).length > 0)
            return;

        setLoadingScreen(true);
        try {
            const payload = {
                actProjIdStrg: inputObject.actProjIdStrg,
                projName: inputObject.projName,
                siteLocation: inputObject.siteLocation,
                dispatchLocation: inputObject.dispatchLocation
            }
            const { message } = await editProjServ(payload, projId);
            notify("success", message);
            navigate(`${route.aProjectinfo}/?projId=${projId}`, { replace: true });
        } catch (error) {
            console.log(error)
            customAlert(error)
        }
        setLoadingScreen(false);
    };

    function validate(values) {
        const errors = {};

        if (!values.actProjIdStrg)
            errors.actProjIdStrg = "Project ID is required!";

        if (!values.projName)
            errors.projName = "Project Name is required!";

        return errors;
    };

    async function handleCancel() {
        navigate(`${route.aProjectinfo}/?projId=${projId}`, { replace: true });
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }


    return (<form onSubmit={handleSubmit} noValidate id='addPo' style={{ padding: 0, height: "100%", width: "100%" }}>
        <Stack direction={"row"} alignItems={'center'} justifyContent={'space-between'} mb={1} mt={0.5} width={"100%"}>
            <BackButton width={"20%"} />
            <Stack direction={"row"} alignItems={'center'} justifyContent={'center'} width={"60%"}>
                <Typography sx={{ fontSize: 18, fontWeight: 500 }}>Edit Project</Typography>
            </Stack>
            <Box width={"20%"} />
        </Stack>
        <BgBoxOld height={"93%"} py={1}>
            {projData && <Stack >
                <Stack sx={{ width: "30%", height: "90%" }} gap={1}>
                    <LabelTxtFieldInfo defaultValue={projData?.actProjIdStrg} name="actProjIdStrg" errMsg={formErrors.actProjIdStrg} title="Project ID *"  {...txtFieldSx} />
                    <LabelTxtFieldInfo defaultValue={projData?.projName} name="projName" errMsg={formErrors.projName} title="Project Name *" {...txtFieldSx} />
                    <LabelTxtFieldInfo defaultValue={projData?.siteLocation} name="siteLocation" title="Site Location" {...txtFieldSx} rows={4} multiline={true} height={100} />
                    <LabelTxtFieldInfo defaultValue={projData?.dispatchLocation} name="dispatchLocation" title="Dispatch Location" {...txtFieldSx} rows={4} multiline={true} height={100} />
                </Stack>
                <Stack direction={"row"} alignItems={"center"} sx={{ width: "50%", justifyContent: "end", mt: 5 }} >
                    <Button variant="outlined" onClick={handleCancel} sx={{
                        fontWeight: 600, height: 40, width: 100, borderRadius: 2, backgroundColor: theme.palette.custom.grey,
                        color: theme.palette.custom.btn, mr: 2,
                    }}>CANCEL</Button>
                    <Button variant="contained" type="submit"
                        sx={{ fontWeight: 600, height: 40, width: 100, bgcolor: theme.palette.custom.btn, color: "white", mr: 10 }}>
                        SAVE</Button>
                </Stack>
            </Stack>}
        </BgBoxOld>
    </form>
    );
}